import { captureException } from '@sentry/react';

import * as analytics from '@benniehealth/core-js/analytics';

import { USER_ROLES } from '@app/constants/user';

let mp = null;
let pending = [];
let failed = false;

function withClient(run) {
  if (mp) {
    run(mp);
  } else if (!failed) {
    pending.push(run);
  }
}

function flush() {
  const queued = pending;
  pending = [];
  queued.forEach(run => run(mp));
}

export const init = (...args) => {
  failed = false;

  return import('mixpanel-browser')
    .then(mod => {
      const client = mod.default ?? mod;
      if (typeof client?.init !== 'function') {
        throw new Error('mixpanel-browser loaded without a usable init()');
      }
      client.init(...args);
      mp = client;
      flush();
    })
    .catch(error => {
      failed = true;
      pending = [];
      captureException(error, {
        tags: { section: 'analytics', action: 'init' },
      });
    });
};

export const disable = () => withClient(client => client.disable?.());

export const setProfile = (...args) =>
  withClient(client => client.people?.set?.(...args));

export const reset = () => withClient(client => client.reset?.());

export const identify = (...args) =>
  withClient(client => client.identify?.(...args));

export const setGroup = (groupKey, groupId) =>
  withClient(client => client.set_group?.(groupKey, groupId));

export const track = (...args) => withClient(client => client.track?.(...args));

export const getAccessType = access => {
  let accessTypeAnalytics;

  if (access === USER_ROLES.HR_ADMIN) {
    accessTypeAnalytics = analytics.admin.SET_ACCESS_HR_ADMIN;
  }

  if (access === USER_ROLES.EMPLOYEE) {
    accessTypeAnalytics = analytics.admin.SET_ACCESS_EMPLOYEE;
  }

  if (access === USER_ROLES.SYSTEM_ADMIN) {
    accessTypeAnalytics = analytics.admin.SET_ACCESS_SYSTEM_ADMIN;
  }

  return accessTypeAnalytics;
};

export const registerOnce = (...args) =>
  withClient(client => client.register_once?.(...args));

export const register = (...args) =>
  withClient(client => client.register?.(...args));
